module.exports = __webpack_public_path__ + "static/media/Michelle_Denisse_JimenezOsorio.7d18e6ab.jpg";